import React from 'react';
import {
  AfterPageProps,
  createApiClient,
  createInitialPropsRedirectToLogin,
  makeAfterComponent,
  preventAuth,
  wrapLayout,
} from '../../@sprinx/react-after-razzle';
import commonThingsToLoad from '../../api/commonThingsToLoad';
import ErrorInternal from '../../components/ErrorInternal';
import CartApprovalPageLayout from './CartApprovalPageLayout';

export type CartApprovalPageProps = AfterPageProps;

const CartApprovalPage: React.FC<CartApprovalPageProps> = ({ error, match }) => {
  if (error) return <ErrorInternal error={error} />;

  const cartId = match.params.id;

  return <CartApprovalPageLayout cartId={cartId} />;
};

CartApprovalPage.displayName = 'CartApprovalPage';

export default makeAfterComponent(
  wrapLayout(CartApprovalPage),
  preventAuth(async ({ match, initialAppProps }) => {
    try {
      if (initialAppProps) {
        const appProps = initialAppProps;
        const apiClient = createApiClient({ accessToken: appProps.auth?.accessToken });
        const commonThings = await Promise.all(commonThingsToLoad.promises({ apiClient }));

        appProps.propagateToState({
          ...commonThingsToLoad.toRegister(commonThings),
        });
      }
      return {};
    } catch (error) {
      if (error.response?.status === 401) {
        return createInitialPropsRedirectToLogin({ match });
      }
      return { error };
    }
  }),
);
